module.exports = __webpack_public_path__ + "static/media/failed-capture-nine.a2116267.png";